import api from './api';

const incomeExpenseService = {
    create: (data) => api.post('/api/income-expense', data),

    list: (params = {}) => api.get('/api/income-expense', { params }),

    summary: (params = {}) => api.get('/api/income-expense/summary', { params }),

    update: (id, data) => api.put(`/api/income-expense/${id}`, data),

    remove: (id) => api.delete(`/api/income-expense/${id}`),

    // ── Operator pay (owner pays an operator from what they entered) ──
    // params: { officeSpaceId, operatorId, dateFrom?, dateTo? } → { configured, payable, paid, remaining, ... }
    operatorPay: (params) => api.get('/api/income-expense/operator-pay', { params }),
    // body: { officeSpaceId, operatorId, dateFrom, dateTo, amount?, recordAsExpense?, note? }
    createOperatorPayout: (body) => api.post('/api/income-expense/operator-pay/payouts', body),
};

export default incomeExpenseService;
